import { Component, Input } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { AlertController, ModalController } from '@ionic/angular';
import { UtilisateursService } from 'src/app/services/app/utilisateurs.service';
import { BcryptVerifier } from 'src/app/utils/bcrypt-verify';
import { verifyArgon2 } from 'src/app/utils/argon2-loader';


import * as bcrypt from 'bcryptjs'; // en haut du fichier
@Component({
  selector: 'app-c-modal-validation-step',
  templateUrl: './c-modal-validation-step.component.html',
  styleUrls: ['./c-modal-validation-step.component.scss'],
})
export class CModalValidationStepComponent {
  @Input({ required: true }) droitsArrs!: [string[][], string[][]];

  form = this.formBuilder.group({
    matricule: this.formBuilder.control(``, Validators.required),
    password: this.formBuilder.control(``, Validators.required)
  });

  constructor(
    private alertController: AlertController,
    private formBuilder: FormBuilder,
    private modalController: ModalController,
    private utilisateursService: UtilisateursService
  ) { }

  async onCheckButtonClick() {
    Object.values(this.form.controls).forEach(ctrl => ctrl.markAsDirty());

    if (!this.form.valid) {
      return false;
    }

    const liste = await this.utilisateursService.getUtilisateurListeInfosAsPromise();
    console.log('Liste complète des utilisateurs récupérée:', liste);
    console.log('Droits requis (droitsArrs) à valider:', this.droitsArrs);

    
    if (!Array.isArray(liste)) {
      console.warn('Liste des utilisateurs introuvable ou invalide');
      return false;
    }

    const found = liste.find(utilisateur => utilisateur.matricule === this.form.value.matricule);

    if (!found) {
      this.alertController.create({
        message: `Utilisateur introuvable`,
        buttons: [`OK`]
      }).then(alrt => alrt.present());
      return false;
    }

    // --- NOUVELLE PARTIE : vérification du mot de passe bcrypt ---
    const passwordInput = this.form.value.password ?? '';
    let validPassword = false;

    if (found.password && found.password.startsWith('$2y$')) {
      const hash = '$2a$' + found.password.substring(4); // bcryptjs ne supporte pas $2y
      validPassword = bcrypt.compareSync(passwordInput, hash);
    } else if (found.password && found.password.startsWith('$argon2id$')) {
      validPassword = await verifyArgon2(passwordInput, found.password);
    }  else {
      
      validPassword = false;
    }
    
    if (!validPassword) {
      this.alertController.create({
        message: `Mot de passe incorrect`,
        buttons: [`OK`]
      }).then(alrt => alrt.present());
      return false;
    }
    // 1) normalise: vire les groupes vides et aplatis d’UN niveau
    // vire les groupes vides et aplatis d’UN niveau sans .flat
    const droitsArrsNet = (this.droitsArrs ?? [])
      .map(group =>
        Array.isArray(group)
          ? group.reduce<string[]>(
              (acc, g) => acc.concat(Array.isArray(g) ? g : []),
              []
            )
          : []
      )
      .filter(group => Array.isArray(group) && group.length > 0);

    console.log('droitsArrsNet (flat1):', droitsArrsNet);

    // --- FIN DE LA NOUVELLE PARTIE ---
    const hasRequiredDroits = Array.isArray(droitsArrsNet) && droitsArrsNet.every(droitsArr =>
      Array.isArray(droitsArr) && (droitsArr.length === 0 || droitsArr.some(droit =>
        typeof droit === 'string' && Array.isArray(found.droits) && found.droits.includes(droit)
      ))
    );

    if (hasRequiredDroits) {
      this.modalController.dismiss({ id: found.id || null });
      return true;
    } else {
      this.alertController.create({
        message: `L'utilisateur n'a pas les droits nécessaires pour autoriser la validation de cette étape.`,
        buttons: [`OK`]
      }).then(alrt => alrt.present());
      return false;
    }
  }

  dismissModal() {
    this.modalController.dismiss();
  }

  async checkPassword(inputPassword: string, hashedPassword: string): Promise<boolean> {
    return BcryptVerifier.compare(inputPassword, hashedPassword);
  }

}
// import { Component, Input } from '@angular/core';
// import { FormBuilder, Validators } from '@angular/forms';
// import { AlertController, ModalController } from '@ionic/angular';
// import { UtilisateursService } from 'src/app/services/app/utilisateurs.service';

// @Component({
//   selector: 'app-c-modal-validation-step',
//   templateUrl: './c-modal-validation-step.component.html',
//   styleUrls: ['./c-modal-validation-step.component.scss'],
// })
// export class CModalValidationStepComponent {
//   @Input({ required: true }) droitsArrs!: [string[][], string[][]];

//   form = this.formBuilder.group({
//     matricule: this.formBuilder.control(``, Validators.required),
//     password: this.formBuilder.control(``, Validators.required)
//   });

//   constructor(
//     private alertController: AlertController,
//     private formBuilder: FormBuilder,
//     private modalController: ModalController,
//     private utilisateursService: UtilisateursService
//   ) { }

//   async onCheckButtonClick() {
//     Object.values(this.form.controls).forEach(ctrl => ctrl.markAsDirty());
//     if (this.form.valid) {
//       const liste = await this.utilisateursService.getUtilisateurListeInfosAsPromise();
//       console.log(this.droitsArrs);
//       if (Array.isArray(liste)) {
//         const found = liste.find(utilisateur => utilisateur.matricule === this.form.value.matricule);
//         if (found !== undefined) {
//           // TODO-pf gérer mot de passe incorrect
//           if (this.droitsArrs.every(droitsArr => droitsArr.every(droits => droits.length === 0 || droits.some(droit => found.droits.includes(droit))))) {
//             this.modalController.dismiss({ id: found.id || null });
//             return true;
//           } else {
//             this.alertController.create({
//               message: `L'utilisateur n'a pas les droits nécessaires pour autoriser la validation de cette étape`, // TODO-Camille précision si nécessaire
//               buttons: [`OK`]
//             }).then(alrt => alrt.present());
//             return false;
//           }
//         }
//         this.alertController.create({
//           message: `Utilisateur introuvable`,
//           buttons: [`OK`]
//         }).then(alrt => alrt.present());
//         return false;
//       }
//       // TODO-pf? gérer pas une liste ou liste vide

//     }
//     return false;
//   }

//   dismissModal() {
//     this.modalController.dismiss();
//   }

// }
